import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddLatestCityPostModal from "../components/AddLatestCityPostModal";
import ReactQuill from "react-quill";

const RecentShowroomAccordian = (props) => {
  const { title, data, setData } = props;
  const prevProps = useRef();
  const [selectedShowroom, selectShowroom] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [recentShowrooms, setRecentShowrooms] = useState([]);

  const handleModal = useCallback((show = false, selectedObj) => {
    show = typeof show === "boolean" && show;
    setShowModal(show);
    selectShowroom(selectedObj);
  }, []);

  useEffect(() => {
    setRecentShowrooms(data?.recentShowrooms);
  }, [data?.recentShowrooms]);

  useEffect(() => {
    if (JSON.stringify(recentShowrooms) !== prevProps?.current?.prevShowroom) {
      setData((preState) => ({ ...preState, recentShowrooms }));
    }

    return () => {
      prevProps.current = {
        prevShowroom: JSON.stringify(recentShowrooms),
      };
    };
  }, [recentShowrooms]);

  const handleShowroom = useCallback((cityObj) => {
    let { index, ...rest } = cityObj;

    if (index !== undefined) {
      setRecentShowrooms((preState) =>
        preState.map((obj, i) => (i === index ? rest : obj))
      );
    } else {
      setRecentShowrooms((preState) => [...preState, cityObj]);
    }
  }, []);

  const handleRemove = useCallback((index) => {
    setRecentShowrooms((preState) => preState.filter((_, i) => i !== index));
  }, []);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e?.target?.checked ?? e;

      setData((preState) => ({ ...preState, [name]: value }));
    },
    [setData]
  );

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography fontWeight={"600"}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="form_comp">
            <label htmlFor="title">Title</label>
            <ReactQuill
              placeholder="Enter title"
              value={data?.title}
              onChange={handleChange("title")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="form_comp">
            <label htmlFor="title">Description</label>
            <ReactQuill
              placeholder="Enter description"
              value={data?.description}
              onChange={handleChange("description")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="btn-container mt15">
            <Button
              variant="contained"
              className="bordered-button float-right"
              onClick={() => handleModal(true)}
            >
              + Add Latest Showroom
            </Button>
          </div>

          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 650, px: 2 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Name
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    City
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {recentShowrooms?.map((showroom, index) => {
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box>
                            <Typography
                              style={{
                                maxWidth: 200,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {showroom?.showroomName}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box
                            sx={{
                              ml: 3,
                            }}
                          >
                            <Typography
                              style={{
                                maxWidth: 400,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {showroom?.address}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">{showroom?.city}</Box>
                      </TableCell>

                      <TableCell
                        align="left"
                        onClick={() =>
                          handleModal(true, {
                            ...showroom,
                            index,
                          })
                        }
                      >
                        <EditIcon />
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() => handleRemove(index)}
                      >
                        <DeleteIcon />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <AddLatestCityPostModal
        open={showModal}
        handleClose={() => setShowModal(false)}
        selectedPost={selectedShowroom}
        handleCityPost={handleShowroom}
      />
    </>
  );
};

export default RecentShowroomAccordian;
